// Search trigger: scroll to top before opening
(function(){
  document.querySelectorAll('details[id*="search"] summary, [data-search-trigger], .header__icon--search, summary.header__icon--search').forEach(t => {
    t.addEventListener('click', () => {
      // Scroll to top con smooth behavior PRIMA di aprire il drawer
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, { passive: true });
  });
  // Anche per modal-dialog (Dawn 14+)
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[is="modal-opener"], .modal-opener');
    if (t && t.closest('[id*="search"], [class*="search"]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, true);
})();
